import { config } from '@/app/config';
import { Logo } from '@/components/ui';

/**
 * Shared frame for every authentication screen: sign-in, registration,
 * password reset and email verification. One white card on the logo's dark
 * purple, with the Wonder mark above the title, so every way into the product
 * looks like the same door.
 *
 * The height leaves room for PublicLayout's 4rem header, so a short form still
 * sits in the middle of a full purple screen.
 */
export function AuthCard({ title, description, children, footer }) {
  return (
    <section className="auth-shell bg-night">
      <div className="app-container flex min-h-[calc(100vh-4rem)] items-center justify-center py-8 sm:py-12">
        <div className="rounded-panel shadow-card bg-surface w-full max-w-md p-6 sm:p-8">
          <div className="text-center">
            <Logo size={48} title={config.appName} className="text-brand-600 mx-auto" />
            <h1 className="text-ink mt-4 text-2xl font-semibold tracking-tight">{title}</h1>
            {description && <p className="text-ink-muted mt-2 text-sm">{description}</p>}
          </div>

          <div className="mt-6">{children}</div>

          {footer && (
            <div className="text-ink-muted mt-6 space-y-2 text-center text-sm">{footer}</div>
          )}
        </div>
      </div>
    </section>
  );
}
